import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

import zh from './zh-CN';
import en from './en';

export const messages = {
  CN: zh,
  EN: en
}

const systemLanguage = navigator.language.includes('CN') ? 'CN' : 'EN';

const localLanguage = localStorage.getItem('language');

export default new VueI18n({
  locale: localLanguage || systemLanguage, // set locale
  messages, // set locale messages
  fallbackLocale: 'CN',
});